/**
 * @generated SignedSource<<5d71e86aced7dd7176cb6096588f15c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksSectionWidgetQuery$data = {
  readonly section: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"asiaDiscoveryWidgetQuery" | "chinaScienceDiscoveryWidgetQuery" | "commentQueueQuery" | "discoveryWidgetPostMagazineQueueQuery" | "focusArticleHomeFocusArticleQuery" | "mostPopularQueueQuery" | "multimediaQuery" | "openQuestionsSeriesDiscoveryWidgetQuery" | "plusWidgetQuery" | "thisWeekInAsiaDiscoveryWidgetQuery" | "trendingTopicTopic">;
  readonly " $fragmentType": "hooksSectionWidgetQuery";
};
export type hooksSectionWidgetQuery$key = {
  readonly " $data"?: hooksSectionWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksSectionWidgetQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksSectionWidgetQuery"
};

(node as any).hash = "422f53b6f53c2217ae78f111a22a2576";

export default node;
